var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.decoder.description)),(_vm.hasSlaves && !_vm.isMultiscreenFormat)?_c('span',_vm._l((_vm.decoder.slave_decoder_serials_and_descriptions),function(slaveDecoder,slaveDecoderIndex){return _c('span',{key:slaveDecoder.serial,staticClass:"grey--text text--darken-1"},[(
      slaveDecoderIndex <
        _vm.decoder.slave_decoder_serials_and_descriptions.length
    )?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(slaveDecoder.description)+"\n  ")])})):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DecoderDescription.vue?vue&type=template&id=3fe98fbe&
// module id = 2471
// module chunks = 5